












































import Vue from 'vue'
import MenuTable from './MenuTable'
import { SubAccountServiceProxy, SubAccountCreateDTO, TenantAppServiceProxy, AppMenuServiceProxy } from '@/service-proxies/app-v2/system.service-proxies'

const subAccountServiceProxy = new SubAccountServiceProxy()
const appMenuServiceProxy = new AppMenuServiceProxy()
const tasp = new TenantAppServiceProxy()
export default Vue.extend({
  name: 'CreateSubAcc',
  components: { MenuTable },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    authorityTree: { // 已授权的职权域
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      loading: false,
      form: this.$form.createForm(this),
      // grantDeptIdList: undefined,
      // grantMenuList: [],
      // remark: '',
      appData: [],
      currentApp: '',
      tableLoading: false,
      permissionData: [],
      currentEdition: null,
      currentAppMenuData: {}, // 当前app下的选中菜单和app版本信息
      appMenus: {} // 暂存app对应的菜单选中状态
    }
  },
  watch: {
    visible(val) {
      if (val) {
        // this.grantDeptIdList = undefined
        this.permissionData = []
        this.appMenus = {}
        this.loadAppData()
      }
    }
  },
  created() {
    // this.loadAppData()
  },
  methods: {
    async loadAppData() {
      const res = await tasp.getCurrentTenantGrantApps()
      this.appData = res
      this.currentApp = this.appData[0].appCode
      this.getAppAuthorizedMenus()
    },
    async getAppAuthorizedMenus() {
      this.tableLoading = true
      const res = await appMenuServiceProxy.getAppAuthorizedMenus(this.currentApp, '')
      this.permissionData = res.menuTree
      this.currentEdition = res.edition
      this.currentAppMenuData = {}
      Object.assign(this.currentAppMenuData, { edition: res.edition })
      this.tableLoading = false
    },
    // 切换app
    changeApp(key: string) {
      // 暂存上一个app的菜单选中状态
      Object.assign(this.currentAppMenuData, {
        checkMap: this.$refs.menuTable.checkMap,
        childMap: this.$refs.menuTable.childMap,
        parentMap: this.$refs.menuTable.parentMap
      })
      this.appMenus[this.currentApp] = this.currentAppMenuData
      // this.appMenus[this.currentApp]['checkMap'] = this.$refs.menuTable.checkMap
      // this.appMenus[this.currentApp]['childMap'] = this.$refs.menuTable.childMap
      // this.appMenus[this.currentApp]['parentMap'] = this.$refs.menuTable.parentMap
      // console.log('appMenus:', this.appMenus)
      this.currentApp = key
      this.getAppAuthorizedMenus()
    },
    async handleCreate() {
      let flag = true
      this.form.validateFields((err: any, values: any) => {
        if (err) {
          flag = false
        }
      })
      if (!flag) {
        return
      }
      let values = this.form.getFieldsValue() // 描述
      this.loading = true
      // 当前菜单
      let temp = Object.keys(this.$refs.menuTable.checkMap)
        .filter(item => item !== 'undefined')
        .filter(item => this.$refs.menuTable.checkMap[item])
        .map(item => ({
          appCode: this.currentApp,
          menuId: item,
          menuEdition: this.currentEdition
        }))
      // 过滤已存储的app下的菜单
      if (this.appMenus.hasOwnProperty(this.currentApp)) {
        delete this.appMenus[this.currentApp]
      }
      // 存储其他所有app下的勾选菜单
      Object.keys(this.appMenus).map(key => {
        Object.keys(this.appMenus[key].checkMap).filter(item => item !== 'undefined')
          .filter(item => this.appMenus[key].checkMap[item])
          .map(item => {
            temp.push({
              appCode: key,
              menuId: item,
              menuEdition: this.appMenus[key].edition
            })
          })
      })

      let deptIds = values.deptId ? values.deptId.map(item => (item)) : []
      let params = {
        grantMenuList: temp,
        remark: values.remark,
        grantDeptIdList: deptIds // 职权域
      } as SubAccountCreateDTO
      // console.log('params：', params)
      try {
        const newId = await subAccountServiceProxy.create(params)
        this.$emit('close', { reload: true, newId: newId })
        this.$message.success(this.$t('page_resource_pool_success'))
      } catch (e) {
        console.log(e)
      }
      this.loading = false
    },
    close() {
      this.$emit('close')
    }
  }
})
